export interface FileObject {
  propertyName: string;
  file: File;
}

export function acharArquivoNoObj(obj: Record<string, unknown>): FileObject[] {
  const files: FileObject[] = [];

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] instanceof File) {
        files.push({
          propertyName: key,
          file: obj[key] as File,
        });
      }
    }
  }

  return files;
}

export function removerArquivosDoObj(
  json: string,
  filesToRemove: FileObject[]
): string {
  const obj = JSON.parse(json);
  const newObj = { ...obj };

  for (const fileToRemove of filesToRemove) {
    const { propertyName } = fileToRemove;

    if (newObj.hasOwnProperty(propertyName)) {
      delete newObj[propertyName];
    }
  }

  return JSON.stringify(newObj);
}